import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  bg?: 'cream' | 'white' | 'sage-light';
}
export function Section({
  children,
  className = '',
  id,
  bg = 'cream'
}: SectionProps) {
  const bgColors = {
    cream: 'bg-cream',
    white: 'bg-white',
    'sage-light': 'bg-sage-light'
  };
  return <section id={id} className={`py-20 md:py-32 ${bgColors[bg]} ${className}`} data-id="element-168">
      <motion.div className="max-w-5xl mx-auto px-6 md:px-12" initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} data-id="element-169">
        {children}
      </motion.div>
    </section>;
}